import React, { useEffect, useMemo, useRef, useState } from "react";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Col, Row } from "reactstrap";
import CardHeader from "@material-ui/core/CardHeader";
import {
    addAssignCompanyList, addResultManagerUser,
    addSupervisor,
    getCompaniesList,
    getResultManagerList, updateResultStatus,
    updateSupervisorStatus
} from "../_redux";
import SVG from "react-inlinesvg";
import {useResultManagerUserUIContext} from "./ResultManagerUserUIContext";
import {useSelector} from "react-redux";
import {
    entityFilter,
    getFilteredAndPaginatedEntities, getPaginationOptions,
    headerSortingClasses,
    sortCaret,
    toAbsoluteUrl
} from "../../../../_metronic/_helpers";
import CustomizedSwitch from "../../../../utils/SuperAdmin/CustomizedSwitch";
import {successToast, warningToast} from "../../../../utils/ToastMessage";
import {fireAlert} from "../../../../utils/SuperAdmin/SweetAlert";
import {FireAlertMessage} from "../../../../utils/SuperAdmin/enums/firAlert.enums";
import {addNotification} from "../../../Admin/modules/Notification/_redux/notification";
import {Card, CardBody, Pagination} from "../../../../_metronic/_partials/controls";
import {SearchText} from "../../../../utils/SearchText";
import CustomizedButtons from "../../../../utils/SuperAdmin/CustomizedButtons";
import TableLoader from "../../../../utils/SuperAdmin/Loader/TableLoader";
import {AutoServingTable} from "../../../../utils/AutoServingTable";
import AssignCompanyResultModal from "./assignCompanyResultModal";
import AddResultManagerUserModal from "./AddResultManagerUserModal";

export default function AddResultManagerUser() {
    const resultManagerUserUIContext = useResultManagerUserUIContext();
    const resultManagerUserUIProps = useMemo(() => resultManagerUserUIContext, [resultManagerUserUIContext]);

    const [modalOpen, setModalOpen] = useState(false);
    const [assignCompanyModal, setAssignCompanyModal] = useState(false);
    const [data, setData] = useState([]);
    const [blocking, setBlocking] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState("");
    const [companyOptions, setCompanyOptions] = useState([]);
    const searchInput = useRef("");
    const [filterEntities, setFilterEntities] = useState([]);

    const user = useSelector((state) => state.auth.user);

    const columns =[
        {
            dataField: "id",
            text: "INDEX",
            sort: true,
            sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "email",
            text: "Email",
            sort: true,
            sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "companies",
            text: "Companies",
            sort: true,
            sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "assignlocation",
            text: "Actions",
            style: { minWidth: "150px" },
            formatter: (cellContent, row) => (
                <>
                    <div
                        className="btn btn-icon mr-4 btn-light btn-hover-primary btn-hover-light-inverse btn-sm mx-3"
                        onClick={() => handleAssignCompany(cellContent, row)}
                    >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG title="Assign locations" src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} />
                    </span>
                    </div>
                    <CustomizedSwitch
                        checked={cellContent[0].user_status}
                        onChange={() => handleUserStatusWithAlert(cellContent, row)}
                        color={"primary"}
                        className={"cursor-pointer"}
                    />
                </>
            ),
        }
    ]
    // Fetch supervisors
    const fetchResultManagerList = () => {
        setBlocking(true);
        getResultManagerList()
            .then((response) => {
                if (response?.isSuccess) {
                    const responseData = response.data;
                    const formattedData = responseData.map((obj, index) => {
                        const locationNames = obj.locations?.map(loc => loc.location_name) || [];
                        const locationValues = obj.locations?.map(loc => ({
                            label: loc.location_name,
                            value: loc.id,
                        })) || [];

                        // ✅ Extract company names here
                        const companyNames = obj.companies?.map(comp => comp.company_name) || [];

                        return {
                            id: index + 1,
                            email: obj.user_email,
                            companies: companyNames.length > 0 ? companyNames.join(", ") : "-", // ✅ show companies
                            locations: locationNames.length > 0 ? locationNames.join(", ") : "-",
                            assignlocation: [
                                {
                                    user_status: obj.user_status,
                                    location: locationValues,
                                    id: obj.id,
                                },
                            ],
                        };
                    });


                    setData(formattedData);
                    setFilterEntities(formattedData);
                }
                setBlocking(false);
            })
            .catch((error) => {
                setBlocking(false);
                warningToast(error?.detail || "Something went wrong!");
            });
    };

    const getAllCompaniesList = () => {

        getCompaniesList().then(response => {
            if (response?.isSuccess) {
                const responseData = response.data;
                const companyValues = responseData?.map(obj => ({
                    label: obj.company_name,
                    value: obj.id,
                })) || [];
                setCompanyOptions(companyValues)
            }
            setBlocking(false);
        })
        .catch((error) => {
            setBlocking(false);
            warningToast(error?.detail || "Something went wrong!");
        });

    }

    useEffect(() => {
        fetchResultManagerList();
        getAllCompaniesList()
    }, []);

    const handleAssignCompany = (cellContent, row) => {
        setSelectedUserId(row);
        setAssignCompanyModal(true);
    };

    const handleUserStatusWithAlert = (cellContent,row) => {
        fireAlert(
            cellContent[0], // row or any object (not required by the callback here)
            FireAlertMessage?.statusChanges,
            () => {
                const updateStatus = {
                    user_status: !cellContent[0].user_status,
                    user_id: cellContent[0].id,
                };

                updateResultStatus(updateStatus)
                    .then((response) => {
                        if (response?.isSuccess) {
                            fetchResultManagerList();
                        }
                    })
                    .catch((error) => {
                        warningToast(error?.detail);
                    });
            }
        );
    };


    const filterResultManager = (e) => {
        const searchStr = e?.target?.value || searchInput.current.value;
        const keys = ["email"];
        entityFilter(data, searchStr, keys, resultManagerUserUIProps.queryParams, setFilterEntities);
    };

    useEffect(() => {
        filterResultManager();
        //eslint-disable-next-line
    }, [data]);

    const currentItems = getFilteredAndPaginatedEntities(
        filterEntities,
        resultManagerUserUIProps.queryParams
    );
    const companyModalClose = () => {
        setAssignCompanyModal(false)
    }

    const toggleResultManagerModal = () => {
        setModalOpen(false);
    }
    const handleAddResultManager = (param) => {
        addResultManagerUser(param)
            .then(response => {
                if (response?.isSuccess) {
                    toggleResultManagerModal();
                    fetchResultManagerList();
                    const notificationData = {
                        notification_message: `Supervisor Added : ${param?.user_email}`,
                        user_id: user.id,
                        type_of_notification: "string",
                        status: true,
                        is_unread: true,
                    };

                    addNotification(notificationData)
                        .then(notificationRes => {
                            if (notificationRes?.isSuccess) {
                                successToast("Supervisor Added Successfully");
                            }
                        })
                        .catch(error => {
                            console.log("Notification Error:", error?.detail);
                        });
                }
            })
            .catch(error => {
                setModalOpen(false);
                console.log(error?.detail || "Something went wrong");
            });

    }

    const submitAssignCompany = (params , userdata) => {
        let uniqueValues = Array.from(
            new Set(params?.map(item => item.value) || [])
        );

       const user_id = userdata?.assignlocation[0]?.id
        addAssignCompanyList(user_id,uniqueValues)
            .then(response => {
                if (response?.isSuccess) {
                    successToast("Assign Company Added Successfully");
                    fetchResultManagerList();
                    companyModalClose()
                }
            })
            .catch(error => {
                setModalOpen(false);
                console.log(error?.detail || "Something went wrong");
            });

    }


    return (
            <Card className="example example-compact fixed-height-card">
                <CardBody className="custom-card-body">
                    <Row className="align-items-center">
                        <Col xs={12} md={6}>
                            <CardHeader title="User Details" className="p-2" />
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="d-flex justify-content-md-end flex-wrap gap-2 mt-2 mt-md-0">
                                <div className="mr-3">
                                    <SearchText reference={searchInput} onChangeHandler={filterResultManager} />
                                </div>
                                <CustomizedButtons
                                    className="btn btn-primary"
                                    title="Add User"
                                    submit={() => setModalOpen(true)}
                                    color="primary"
                                />
                            </div>
                        </Col>
                    </Row>

                    <hr />

                    <div className={"table-wrapper-common"}>
                        {blocking ? (
                            <div className="table-loader-wrapper">
                                <TableLoader rows={currentItems?.length} columns={columns.length} />
                            </div>
                        ) : (
                            <>
                                <PaginationProvider pagination={paginationFactory(getPaginationOptions(filterEntities.length, resultManagerUserUIProps.queryParams))}>
                                    {({ paginationProps, paginationTableProps }) => (
                                        <>
                                            <AutoServingTable
                                                columns={columns}
                                                items={currentItems}
                                                tableChangeHandler={resultManagerUserUIProps.setQueryParams}
                                                paginationTableProps={paginationTableProps}
                                                className={currentItems.length > 0 ? "table-wrapper-common" : "table-wrapper-common-no-data"}
                                                noDataIndication={() => (
                                                    <div className="table-noDataIndication">No Data Found</div>
                                                )}
                                            />
                                            {currentItems.length > 0 && (
                                                <Pagination paginationProps={paginationProps} />)}
                                        </>
                                    )}
                                </PaginationProvider>

                            </>
                        )}
                    </div>



                    {assignCompanyModal && (
                        <AssignCompanyResultModal
                            assignLoading={false}
                            companyModalClose={companyModalClose}
                            selectedUser={selectedUserId}
                            companyOptions={companyOptions}
                            modalOpen={assignCompanyModal}
                            submit={submitAssignCompany}

                        />
                    )}
                    {modalOpen && (
                        <AddResultManagerUserModal
                            modalOpen={modalOpen}
                            toggleResultManagerModal={toggleResultManagerModal}
                            handleAddResultManager={handleAddResultManager}
                        />
                    )}
                </CardBody>
            </Card>
    );
}
